module.exports = __webpack_public_path__ + "static/img/professional-group.0524eba5.png";